import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { actionTypes } from '../reducer';

function* updateUser() {
  yield requestSaga({
    actionType: actionTypes.update,
    request: dataProvider.updateOne,
    resource: resources.user.index,
  });
}

export default updateUser;
